/* eslint-disable max-classes-per-file */

const CONDITIONS = {
    'Equal': function(field, vc, ctx) {
        return {
            events: events(field, vc),
            test: function(){
                const currentValues = values(ctx, vc.matcher);
                window.console.debug('JN', 'Equal', currentValues, '==', vc.value)
                return vc.value.some((v) => currentValues.some((cv) =>  cv == v))
            }
        }
    },

    'NotEqual': function(field, vc, ctx) {
        return {
            events: events(field, vc),
            test: function(){
                const currentValues = values(ctx, vc.matcher);
                window.console.debug('JN', 'NotEqual', currentValues, '!=', vc.value)
                return !vc.value.some((v) => currentValues.some((cv) =>  cv == v))
            }
        }
    },

    'HigherThan': function(field, vc, ctx) {
        return {
            events: events(field, vc),
            test: function(){
                const currentValues = values(ctx, vc.matcher);
                window.console.debug('JN', 'HigherThan', currentValues, '>', vc.value)

                const testAsNum = toNumber(vc.value);
                return currentValues.some((cv) => {
                    if(cv == "") return false;

                    const currAsNum = toNumber(cv);

                    if (isNaN(currAsNum) || isNaN(testAsNum)) {
                        return String(cv) > String(vc.value);

                    } else {
                        return currAsNum > testAsNum;
                    }
                })
            }
        }
    },

    'HigherThanOrEqual': function(field, vc, ctx) {
        return {
            events: events(field, vc),
            test: function(){
                const currentValues = values(ctx, vc.matcher);
                window.console.debug('JN', 'HigherThanOrEqual', currentValues, '>=', vc.value)

                const testAsNum = toNumber(vc.value);
                return currentValues.some((cv) => {
                    if(cv == "") return false;

                    const currAsNum = toNumber(cv);

                    if (isNaN(currAsNum) || isNaN(testAsNum)) {
                        return String(cv) >= String(vc.value);

                    } else {
                        return currAsNum >= testAsNum;
                    }
                })
            }
        }
    },

    'LowerThan': function(field, vc, ctx) {
        return {
            events: events(field, vc),
            test: function(){
                const currentValues = values(ctx, vc.matcher);
                window.console.debug('JN', 'LowerThan', currentValues, '<', vc.value)
                const testAsNum = toNumber(vc.value);
                return currentValues.some((cv) => {
                    if(cv == "") return false;

                    const currAsNum = toNumber(cv);

                    if (isNaN(currAsNum) || isNaN(testAsNum)) {
                        return String(cv) < String(vc.value);

                    } else {
                        return currAsNum < testAsNum;
                    }
                })
            }
        }
    },

    'LowerThanOrEqual': function(field, vc, ctx) {
        return {
            events: events(field, vc),
            test: function(){
                const currentValues = values(ctx, vc.matcher);
                window.console.debug('JN', 'LowerThanOrEqual', currentValues, '<=', vc.value)
                const testAsNum = toNumber(vc.value);
                return currentValues.some((cv) => {
                    if(cv == "") return false;

                    const currAsNum = toNumber(cv);

                    if (isNaN(currAsNum) || isNaN(testAsNum)) {
                        return String(cv) <= String(vc.value);

                    } else {
                        return currAsNum <= testAsNum;
                    }
                })
            }
        }
    },

    'And': function(field, vc, ctx) {
        const subs = vc.conditions.map((cond) => {
            const condition = CONDITIONS[cond.type](field, cond, ctx);
            return condition;
        })

        return {
            events: () => subs.flatMap((sub) => sub.events()),
            test: () => {
                window.console.group('JN', 'viz', 'And', field.fieldDefinition.name);
                const result = subs.every((sub) => sub.test());
                window.console.groupEnd();
                return result;
            }
        }
    },

    'Or': function(field, vc, ctx) {
        const subs = vc.conditions.map((cond) => {
            const condition = CONDITIONS[cond.type](field, cond, ctx);
            return condition;
        })

        return {
            events: () => subs.flatMap((sub) => sub.events()),
            test: () => {
                window.console.group('JN', 'viz', 'Or', field.fieldDefinition.name);
                const result = subs.some((sub) => sub.test())
                window.console.groupEnd();
                return result;
            }
        }
    }
}

const toNumber = function(value) {
   return Number(value.replace(/,/g, '.'))
}

const events = function(field, vc) {
    return () => {
        if(vc.matcher.type === 'Parent'){
            return ['field-value-change-' + field.parent];

        } else {
            const name = vc.matcher.name;
            return ['field-value-change-byName-' + encodeURIComponent(name)];
        }
    }
}

const values = function(ctx, matcher){
    const raw = matcher.type === 'Parent'
        ? ( ctx.parent.getValue() ?? "" )
        : ctx.findValue(matcher.name);
    // we split because of $multiple fields, that have values separated by the null byte
    return String(raw).split('\0');
}

const hydrate = function(field, ctx) {
    const vc = field.fieldDefinition.visibilityCondition;

    return CONDITIONS[vc.type](field, vc, ctx);
}

export { hydrate };
